import * as React from "react";

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number;
}

export function Spinner({ size = 15, style, className, ...props }: SpinnerProps) {
  return (
    <span
      className={["inline-block animate-spin rounded-full", className]
        .filter(Boolean)
        .join(" ")}
      style={{
        width: size,
        height: size,
        border: "2px solid currentColor",
        borderTopColor: "transparent",
        opacity: 0.7,
        ...style,
      }}
      role="status"
      aria-label="로딩 중"
      {...props}
    />
  );
}
